export default __webpack_public_path__ + "static/media/help_sub-photo_sample3.6c7cd54e.png";